const features = [
  '"The next small thing in web development"',
  'A web-application framework, inspired by Next.js',
  'But it uses Svelte instead of React',
  'Server side rendering, code splitting, bundling, lazy-loading, etc.',
  "Bundles are 'hydrated' client side",
  'Not yet at version 1.0',
];

export default features;
